import { useDashboardIdentity } from './useDashboardIdentity';
import { useQuery } from '@tanstack/react-query';
import type { DashboardAnomaliesResponse } from '@evi/shared';
import { fetchDashboardAnomalies } from '@/lib/api';

/**
 * React Query hook for the anomaly alerts widget.
 *
 * Live: charger events (online, offline, connector status) refetch
 * it through LiveUpdatesProvider, and the server's 30s cache is
 * rebuilt after any charger change, so there is no poll.
 *
 * `staleTime: 30_000` deduplicates rapid remounts (toggling the
 * widget in / out of the layout, navigating away + back) so we
 * don't refetch on top of the server cache.
 */
export function useDashboardAnomalies(limit?: 'all' | number) {
  const identity = useDashboardIdentity();
  return useQuery<DashboardAnomaliesResponse>({
    queryKey: ['dashboard', identity, 'anomalies', limit ?? 'preview'],
    queryFn: () => fetchDashboardAnomalies(limit),
    staleTime: 30_000,
  });
}
